import React, { Component } from "react";
import { CSVLink } from "react-csv";
import { dataUser } from "../Helpers/util";
import SwIconButton from "../Common/SwIconButton/SwIconButton";
import AntDDropdown from "../Common/AntDDropdown/AntDDropdown";
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class ParkingReqSortNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: false,
      parkingData: props.parkingInfo,
      userRole: (UserObj && UserObj.role_data) ? UserObj.role_data : [],
    };
    this.handelDropdown = this.handelDropdown.bind(this);
  }

  componentWillReceiveProps() {
    this.setState({
      parkingData: this.props.parkingInfo
    })
  }

  componentDidMount() {
    this.refreshPage();
  }

  handelDropdown() {
    this.setState({
      dropdown: !this.state.dropdown,
    });
  }

  setSelectSort = (key) => {
    const params = { sort_by: key };
    this.props.sendSortToParent(params);
  };

  refreshPage = () => {
    this.props.sendSortToParent(null);
  };

  render() {
    const userRole = this.state.userRole.find(element => element.service_id == '15')
    const headers = [
      { label: "Id", key: "rec_id" },
      { label: "Location", key: "location_name" },
      { label: "Email", key: "email" },
      { label: "Phone", key: "phone" },
      { label: "Status", key: "status" },
      { label: "User Id", key: "user_id" },
      { label: "User Name", key: "user_name" },
      { label: "Vehicle Number", key: "vehicle_number" },
      { label: "Vehicle RC", key: "vehicle_rc" },
      { label: "Vehicle Wheelers", key: "wheeler" },
    ];
    const menuItems = [
      {
        key: "sort",
        label: "Sort by",
        icon: <i className="bi bi-sort-down-alt"></i>,
        children: [
          {
            key: "vehicle_number",
            label: "Vehicle Number",
            className: 'SortingMenu',
          },
          {
            key: "status",
            label: "Status",
            className: 'SortingMenu',
          },
        ],
      },

      ...(userRole && userRole.role_for_write === "1"
        ? [
            {
              key: "export",
              label: (
                <CSVLink
                  filename="Parking.csv"
                  data={
                    this.state.parkingData
                      ? this.state.parkingData
                      : []
                  }
                  headers={headers}
                  className="innertext"
                >
                  Export Parking Data
                </CSVLink>
              ),
              icon: <i className="bi bi-download"></i>,
            },
          ]
        : []),
      {
        key: "refresh",
        label: "Refresh List",
        icon: <i className="bi bi-arrow-clockwise"></i>,
      },
    ];

    return (
      <>
      <li className="ToHideMobile">
        <AntDDropdown
        trigger={["click"]}
        placement="bottomRight"
        menu={{
          items: menuItems,
          onClick: ({ key }) => {
            if (key === "vehicle_number" || key === "status") {
              this.setSelectSort(key);
            }

            if (key === "refresh") {
              this.refreshPage();
            }
          },
        }}
      >
        <SwIconButton size="sm">
          <i className="bi bi-list" />
        </SwIconButton>
      </AntDDropdown>
</li>
      </>
    );
  }
}

export default ParkingReqSortNew;
